// global constants
export const DATE_RANGE_SELECTOR = [
    { value: '30d', label: 'last 30 days' },
    { value: '3m', label: 'last 3 months' },
    { value: '1y', label: 'last 1 year' },
    { value: '2y', label: 'last 2 year' },
    { value: '3y', label: 'last 3 year' },
];

export const PHYSICIAN_ENGAGEMENT_CHANNELS = [
    'All',
    'E-mail',
    'Programmatic',
    'Direct Mail',
    'EHR',
    'Mobile',
    'Peer to Peer',
    'Point of Care',
];

export const CAMPAIGN_GENERATE_TYPE_MANUAL = 'MANUAL';
export const CAMPAIGN_GENERATE_TYPE_ALGORITHM = 'ALGORITHM';

export const TEMPLATE_ID_BANNER_AD = 1;
export const TEMPLATE_ID_EMAIL = 2;
export const TEMPLATE_ID_SMS = 3;
export const TEMPLATE_ID_SALES_REP = 4;
export const TEMPLATE_ID_CUSTOM_MEDIA = 5;
export const TEMPLATE_ID_VIDEO = 6;

export const HEADER_TITLES = {
    '/home': 'Dashboard',
    '/home/campaigns': 'Campaigns',
    '/home/queries': 'Queries',
    '/home/physicians': 'Physicians',
    '/home/physician_analysis':
        'PharmaForceIQ Target List Affinity Analysis Report',
    '/home/sources': 'Data Sources',
    '/home/sources/history': 'Data Sources',
    '/home/affinity_hub': 'Affinity Hub',
    '/home/settings': 'Settings',
    '/home/engagement/digital': 'Digital Physician Engagement',
    '/home/engagements/digital': 'Digital Engagement',
    '/home/engagement/total': 'Total Physician Engagement',
    '/home/engagement/field': 'Field Physician Engagement',
    '/home/web_metrics': 'Web Metrics',
    '/home/AlwaysOn': 'Always On',
    '/home/top_prescribers': 'Dashboard',
    '/home/files': 'Files',
    '/home/triggers_summary': 'Triggers Summary',
    '/home/engagement/paid_media_engagement': 'Paid Media Engagement',
    '/home/engagement/paid_search_engagement': 'Paid Search Engagement',
    '/home/engagement/website_engagement': 'Website Engagement',
    '/home/files': 'Files',
    '/home/triggers_summary': 'Triggers Summary',
    '/home/creatives': 'Creatives',
    '/home/PaidSearch': 'Paid Search',
};

export const MENU_ITEM = {
    Dashboard: 1,
    Campaigns: 2,
    Queries: 3,
    Physicians: 4,
    'PharmaForceIQ Target List Affinity Analysis Report': 4,
    'Data Sources': 5,
    'Affinity Hub': 6,
    Settings: 7,
    Files: 8,
    'Digital Physician Engagement': 1,
    'Total Physician Engagement': 1,
    'Field Physician Engagement': 1,
    'Web Metrics': 1,
    'Always On': 1,
    'Paid Media Engagement': 1,
    'Paid Search Engagement': 1,
    'Website Engagement': 1,
    Creatives: 9,
};

export const MENU_ITEM_IDS = {
    1: '/home',
    2: '/home/campaigns',
    3: '/home/queries',
    4: '/home/physicians',
    5: '/home/sources',
    6: '/home/affinity_hub',
    7: '/home/settings',
    8: '/home/files',
    2: '/home/campaigns',
    3: '/home/queries',
    4: '/home/physicians',
    5: '/home/sources',
    6: '/home/affinity_hub',
    7: '/home/settings',
    8: '/home/files',
    9: '/home/creatives',
};

export const LEVELS = {
    1: 'Very Low',
    2: 'Low',
    3: 'Medium',
    4: 'High',
    5: 'Very High',
};

export const DG_COLOR_SHADES = {
    'Very Low': '#FEF0C7', // Warning 100
    Low: '#FEC84B', // Warning 300
    Medium: '#F79009', // Warning 500
    High: '#B54708', // Warning 700
    'Very High': '#7A2E0E', // Warning 900
};

export const PI_COLOR_SHADES = {
    'Very Low': '#D1FADF', // Success 100
    Low: '#6CE9A6', // Success 300
    Medium: '#12B76A', // Success 500
    High: '#027A48', // Success 700
    'Very High': '#054F31', // Success 900
};

export const PP_COLOR_SHADES = {
    'Very Low': '#E0F2FE', // Blue Light 100
    Low: '#7CD4FD', // Blue Light 300
    Medium: '#0BA5EC', // Blue Light 500
    High: '#026AA2', // Blue Light 700
    'Very High': '#0B4A6F', // Blue Light 900
};

export const PREFERENCE = {
    All: 'All',
    '1st Preference': '1st_preference',
    '2nd Preference': '2nd_preference',
    '3rd Preference': '3rd_preference',
};

export const TOPICS = {
    EFF: 'Efficacy',
    SAF: 'Safety',
    MGT: 'Management',
    ACC: 'Access',
    DOS: 'Dosing',
    MOA: 'Mechanism of Action',
    PRO: 'Patient Profile',
    SUP: 'Patient Support',
    '': '-',
};

export const ECHO_TYPE = {
    0: 'Non Engaged',
    1: 'Engaged',
    2: 'Default',
};

export const TARGET_LIST_DIGITAL_VS_NON_DIGITAL = {
    DG: '#AD509E',
    PP: '#F3DBF1',
    PI: '#DB97D2',
};

export const AFFINITY_HUB_DIGITAL_VS_NON_DIGITAL = {
    DG: '#AD509E',
    PP: '#F3DBF1',
    PI: '#DB97D2',
};

export const DISTINCT_PARTNERS = [
    'ASCO',
    'Medpage',
    'Programmatic',
    'Aggrego Oncology',
    'PlatformQ',
    'Connexions360',
    'Peer Direct',
    'Sermo',
    'Alert Marketing',
    'Haymarket',
    'OptimizeRx',
    'OncLive',
    'RxNT',
    'Doximity',
    'EverydayHealth',
    'Oncology Learning Network',
    'The Oncologist',
    'NuMedis',
    'EHS',
    'Remedy Health Media',
    'DG Connect',
    'PDQ',
    'i-Path',
    'JAMA Oncology',
    'The Lancet Oncology',
    'Facebook',
    'LinkedIn',
    'The Trade Desk',
    'PulsePoint',
    'Client',
    'Pfizer Pilot',
    'Targeted Onco',
    'zerodha',
    'Jam',
    'jj',
    'Deep Intent',
    'Veeva',
    'Test Ajay Partner',
    'Peer to Peer',
    'Always On',
    'Always on test',
    'ABC',
    'TestP',
    'Manual',
    'Medscape',
    'NEJM',
    'testpartnerV1',
    'test',
    'BioPharm',
    'JCO',
    'Pulse Point',
    'Physician Weekly',
    'Targeted Oncology',
    'OBR Oncology',
    'HEALIO',
    'REACHMD',
    'VuMedi',
    'Lancet',
    'JAMA',
    'MDLinx',
    'Doximity',
    'Epocrates',
    'ViiV',
    'Story Soft',
    'SalesForce Marketing Cloud',
];

export const DISTINCT_CHANNELS = [
    'Email',
    'SMS',
    'Sales Rep',
    'Banner Ad',
    'EHR',
    'In Person',
    'Virtual',
    'Point Of Care',
    'Peer to Peer',
    'Social Media',
    'Direct Mail',
    'Programmatic',
    'mobile',
    'Channels-1',
    'Endemic Social Media',
    'Custom Media',
    'BEmail',
    'Website Analytics',
    'Banner ads',
    'Web Matrix',
    'Always On',
    'Video Call',
    'Test',
    'TestC',
    'TestChannels2',
    'testTest',
    'testTestasada',
    'Phone Call',
    'Personal F2F',
    'Virtual Presentation',
    'Rep Triggered Digital',
    'EndemicDisplay',
    'Banner',
];

export const colors = [
    '#FEC84B',
    '#6CE9A6',
    '#9EA5D1',
    '#FAA7E0',
    '#7CD4FD',
    '#84CAFF',
    '#FEB273',
    '#FEA3B4',
    '#A4BCFD',
    '#BDB4FE',
    '#667085',
    '#F79009',
    '#12B76A',
    '#4E5BA6',
    '#0BA5EC',
    '#EE46BC',
    '#2E90FA',
    '#F63D68',
    '#7A5AF8',
    '#FB6514',
    '#6172F3',
];
export const primaryColors = [
    '#E9BEE3',
    '#DB97D2',
    '#C76EBA',
    '#AD509E',
    '#8C3F7D',
    '#733567',
    '#733567',
];

export const PEER_TO_PEER_AFFINITY = ['In-Person', 'Virtual'];

export const ENGAGEMENT = ['Engaged', 'Not Engaged'];

export const PHYSICIAN_SEGMENT = [
    'IBM',
    'TBM',
    'NP/PA',
    'Specialists',
    'Community Oncologists',
    'Test Believer',
    'Cautious Adopter',
    'Unassigned',
    'Test Non Believer',
    'Full List',
    'IO/Chemo Believer',
    'Capmatinib Believer',
    'Other Targeted Therapy',
    'UNASSIGNED',
];

export const tokenExpiryDropdownOptions = [
    { label: '1 day', value: 1 },
    { label: '2 days', value: 2 },
    { label: '3 days', value: 3 },
    { label: '4 days', value: 4 },
    { label: '5 days', value: 5 },
    { label: '6 days', value: 6 },
    { label: '7 days', value: 7 },
];

export const CONNECTION_TYPE = [
    { label: 'Manual', value: 'manual' },
    { label: 'API', value: 'api' },
];

export const STORAGE_TYPE = [
    { label: 'S3', value: 's3' },
    { label: 'SFTP', value: 'sftp' },
];

export const REZLIDHIA_COMPANY_ID = 33;

export const XEVINAPANT_COMPANY_ID = 37;
export const REGENERON_COMPANY_ID = 41;

export const FIELD_ENGAGEMENT_STATUS = [
    { label: 'All', value: 'all' },
    { label: 'Completed', value: 'completed' },
    { label: 'Dismissed', value: 'dismissed' },
];

export const STATE_CODES = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arizona: 'AZ',
    Arkansas: 'AR',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
};

export const BREAKDOWN = ['State', 'District'];

export const TEPMETKO_COMPANY_ID = 3;

export const BAVENCIO_COMPANY_ID = 16;

export const campaignSummaryTableHeaders = [
    'Total Counts',
    'Channel',
    'Vendor',
    'Topic',
    'Branded',
];

export const S3_BUCKET_OBJECT_URL =
    'https://pfiq-v1-dev.s3.us-west-2.amazonaws.com/Rx_images';

export const BAVENCIO_COMPANY_USERS_TO_SHOW_EXTRA_TABS = [
    'adityav@pharmaforceiq.com',
    'bharat.ramachandran@emdserono.com',
    'rachel.hansard@emdserono.com',
    'vipin@pharmafoceiq.com',
];

export const channelDefinitions = {
    Programmatic:
        "Non-endemic reach by displaying client banner ads on HCP's IP address such that the ad would follow them across key websites the HCP visits for the next 48 hours.",
    eNewsletters:
        'Client banner ads of interest with 100% SOV places in the newsletters sent through to the HCPs of interest by select endemic vendors.',
    'Endemic Display':
        'Client banner ads placed on closed physician-only platforms.',
    Email: ' Client email content sent out directly to HCPs of interest through 3rd party endemic vendors.',
    EHR: 'Client banner ads placed across all 6 screens within the EMR systems for HCPs of interest.',
    'Custom Media':
        'Long form HCP content placed on 3rd party sites to drive deeper engagement and education.',
    'Endemic Social Media':
        'Client banner ad placed on HCP only social media platforms.',
};

export const KpiDefinition = [
    {
        key: 'Bounce rate',
        definition:
            'The percentage of visitors who land on a page on the site and leave in less than 30 seconds.',
    },
    {
        key: 'Quality Visit Rate',
        definition:
            'The percentage of visits that meet predefined criteria for engagement or value, such as duration, pages viewed, or specific actions taken.',
    },
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on the landing site.',
    },
    {
        key: 'Quality Visits',
        definition:
            'Site visitors identified as the audience or people visiting the website and taking at least one of the preferred actions: review the entire landing assets, visit two or more landing pages, download any material from the landing site, or spend over 30 seconds on the landing site.',
    },
    // {
    //     key: 'Average Session Duration',
    //     definition: 'The average length of a session measured over a specific period of time.'
    // }
];
export const ReplimuneHCPDefinition = [
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on a landing page.',
    },
    {
        key: 'Average Session Duration',
        definition:
            'Average length of a session measured over a specific period of time.',
    },
    {
        key: 'Engaged Session',
        definition: '30 seconds or more, 1 or more click on the website.',
    },
    {
        key: 'Bounce Rate',
        definition: '<10 seconds on the website.',
    },
    {
        key: 'Quality Visit Rate',
        definition:
            'Percentage of sessions that is a quality visit among total number of sessions.',
    },
    {
        key: 'Quality Visits',
        subItems: [
            { key: '2 clicks or more on navigation or toggle' },
            { key: 'Completion of the contact us form ' },
            { key: '1 or more PDF Downloaded ' },
        ],
    },
    {
        key: 'Quality Visits - Specific to Audience ',
        subItems: [
            {
                key: 'Medical Oncologists',
                subItems: [
                    { key: 'Scroll from Evolution of OI to Collaboration' },
                ],
            },
            {
                key: 'Medical Oncologists - Hand Holder',
                subItems: [
                    {
                        key: 'Click on Lack of SOC for ICI-progressed Patient tab',
                    },
                    {
                        key: 'Website scroll completion from challenges of Adv. Melanoma to Multidisciplinary',
                    },
                ],
            },
            {
                key: 'Interventional Radiologist',
                subItems: [
                    { key: 'Reaching Multidisciplinary with scroll or click' },
                    {
                        key: 'Any scroll to website prior to multi-disciplinary',
                    },
                ],
            },
        ],
    },
    {
        key: 'New Users',
        definition:
            'The number of people who have not visited the website before the specified date range.',
    },
    {
        key: 'Returning Users',
        definition:
            'The number the people who have already visited the website before the specified date range.',
    },
];

export const ReplimuneDTCDefinition = [
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on a landing page.',
    },
    {
        key: 'Average Session Duration',
        definition:
            'Average length of a session measured over a specific period of time.',
    },
    {
        key: 'Engaged Session',
        definition: '30 seconds or more, 1 or more click on the website.',
    },
    {
        key: 'Bounce Rate',
        definition: '<10 seconds on the website.',
    },
    {
        key: 'Quality Visit Rate',
        definition:
            'Percentage of sessions that is a quality visit among total number of sessions.',
    },
    {
        key: 'Quality Visits',
        subItems: [
            { key: 'Downloaded brochure' },
            { key: 'Watched at least 1 video' },
            { key: 'Completed Opt-in form' },
        ],
    },
    {
        key: 'New Users',
        definition:
            'The number of people who have not visited the website before the specified date range.',
    },
    {
        key: 'Returning Users',
        definition:
            'The number the people who have already visited the website before the specified date range.',
    },
];

export const PimicotinibDTCDefinition = [
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on a landing page.',
    },
    {
        key: 'Average Session Duration',
        definition:
            'Average length of a session measured over a specific period of time.',
    },
    {
        key: 'Engaged Session',
        definition: '10 seconds or more on the website.',
    },
    {
        key: 'Bounce Rate',
        definition: '<10 seconds on the website.',
    },
    {
        key: 'New Users',
        definition:
            'The number of people who have not visited the website before the specified date range.',
    },
    {
        key: 'Returning Users',
        definition:
            'The number the people who have already visited the website before the specified date range.',
    },
];

export const ReplimuneClinicalTrialDef = [
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on a landing page.',
    },
    {
        key: 'Average Session Duration',
        definition:
            'Average length of a session measured over a specific period of time.',
    },
    {
        key: 'Engaged Session',
        definition: '30 seconds or more, 1 or more click on the website.',
    },
    {
        key: 'Bounce Rate',
        definition: '< 10 seconds on the website.',
    },
    {
        key: 'Quality Visit Rate',
        definition:
            'Percentage of sessions that is a quality visit among total number of sessions.',
    },
    {
        key: 'Quality Visits',
        subItems: [
            { key: 'Contact us Form Submission on the full site' },
            { key: 'Specific to IG-3 page: Zip code search' },
            {
                key: 'Specific to IG-3 page: “Print” button on clinical trial overview',
            },
            {
                key: 'Specific to IG-3 page: Clicking to email clinical trial team',
            },
            { key: 'Medical Affairs: Entered or downloaded any publications' },
        ],
    },
    {
        key: 'New Users',
        definition:
            'The number of people who have not visited the website before the specified date range.',
    },
    {
        key: 'Returning Users',
        definition:
            'The number the people who have already visited the website before the specified date range.',
    },
];
export const KpiDefinitionReplimune = [
    {
        key: 'Quality Visits',
        definition:
            'Quality Visits defined as the audience or people who download any material, visit the website for >30 seconds, clicks 2 or more times on the website which includes videos or navigation, signed up on Website through submitted form on "Learn More" tab.',
    },
    {
        key: 'Events Per Session',
        definition: 'The average number of events per session.',
    },
    {
        key: 'Sessions',
        definition:
            'Total visits and interactions a user takes on the landing site.',
    },
    {
        key: 'Average Session Duration',
        definition:
            'The average length of a session measured over a specific period of time.',
    },
];
export const triggerTableDefinitions = [
    {
        key: 'Digital Engagement Column',
        subItems: [
            {
                key: 'High',
                subItems: [
                    {
                        key: '3< distinct engagements (clicks/open) across digital assets served',
                    },
                ],
            },
            {
                key: 'Medium',
                subItems: [
                    {
                        key: '>1 - 3< distinct engagements (clicks/open) across digital assets served',
                    },
                ],
            },
            {
                key: 'Low',
                subItems: [
                    {
                        key: '1 engagement (click/open) across digital assets served',
                    },
                ],
            },
        ],
    },
    {
        key: 'FMT Match Column',
        subItems: [
            {
                key: 'Match',
                subItems: [{ key: 'NPI is already on the FMT list' }],
            },
            {
                key: 'Recommend',
                subItems: [
                    {
                        key: 'HCP is considered a "High Digital Engager" so categorized as someone interested in learning more',
                    },
                ],
            },
        ],
    },
];

export const excludes_triggerTableDefinitions_keys = [
    'FMT Match Column',
    'Match',
    'Recommend',
];

export const prodQaCompnies = [161, 33];

export const prodQaCompniesTriggerSummary = [161, 33, 62];

export const showCreative = [152, 140, 59];

export const hideDownloadButtonCompanies = [3];

export const hideBounceRateCompanies = [61, 66, 64, 94];

// Companies whose target list analysis tooltips show HCP counts next to percentages
export const hcpCountTooltipCompanies = [16];
